export class SessionArchiveError extends Error {
    code;
    name = "SessionArchiveError";
    constructor(code, message) {
        super(message);
        this.code = code;
    }
}
//# sourceMappingURL=error.js.map